import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import {
  portalRosterEmptyMessage,
  portalRosterStopView,
  portalRosterTelHref,
  type PortalRosterRow,
} from "./fmb-distributor-portal-roster";

type PortalRosterListProps = {
  loading: boolean;
  hasDailyMenu: boolean;
  rosterCount: number;
  rows: PortalRosterRow[];
};

export default function PortalRosterList(props: PortalRosterListProps) {
  const empty = portalRosterEmptyMessage({
    loading: props.loading,
    hasDailyMenu: props.hasDailyMenu,
    rosterCount: props.rosterCount,
    visibleCount: props.rows.length,
  });

  if (empty) {
    return (
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {empty}
        </Typography>
      </Paper>
    );
  }

  return (
    <Stack spacing={1}>
      {props.rows.map((it) => {
        const stop = portalRosterStopView(it);
        const telHref = portalRosterTelHref(stop.phone);
        const meta = [stop.name, stop.itsNo ? `ITS ${stop.itsNo}` : ""].filter(Boolean).join(" · ");

        return (
          <Paper key={it.id} variant="outlined" sx={{ px: 2, py: 1.5 }}>
            <Stack spacing={0.75}>
              <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1}>
                <Stack spacing={0.25}>
                  <Typography variant="caption" color="text.secondary">
                    Thali no
                  </Typography>
                  <Typography
                    variant="h6"
                    component="div"
                    sx={(theme) => ({ fontWeight: theme.typography.fontWeightMedium })}
                  >
                    {stop.thaliNo}
                  </Typography>
                </Stack>
                {stop.thaliType ? (
                  <Chip size="small" label={stop.thaliType} color="primary" variant="outlined" />
                ) : null}
              </Stack>
              <Typography
                variant="body1"
                sx={(theme) => ({
                  fontWeight: theme.typography.fontWeightMedium,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                })}
              >
                {stop.address}
              </Typography>
              {meta ? (
                <Typography variant="caption" color="text.secondary">
                  {meta}
                </Typography>
              ) : null}
              {telHref ? (
                <Link
                  href={telHref}
                  underline="hover"
                  variant="body2"
                  sx={{ alignSelf: "flex-start", py: 0.5 }}
                >
                  {stop.phone}
                </Link>
              ) : null}
            </Stack>
          </Paper>
        );
      })}
    </Stack>
  );
}
